import { render, staticRenderFns } from "./IndexBdc.vue?vue&type=template&id=6774110c&scoped=true&"
import script from "./IndexBdc.vue?vue&type=script&lang=js&"
export * from "./IndexBdc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6774110c",
  null
  
)

export default component.exports